import { SvgIcon } from '@material-ui/core';

export const IconStations = () => {
  const pixelSize = 24;

  return (
    <SvgIcon
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M7 3a1 1 0 0 0-2 0v18a1 1 0 1 0 2 0V3zM3 9a1 1 0 0 0-2 0v6a1 1 0 1 0 2 0V9zm7-3a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1zm5 4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4zm3-5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1zm5 4a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V9z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
